import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/contrast-checker/pages/CalculatorPage";

export const Route = createFileRoute("/contrast-checker")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/contrast-checker",
      title: m.cc_meta_title(),
      description: m.cc_meta_description(),
      toolName: m.cc_tool_name(),
      faqs: [
        { q: m.cc_faq_q1(), a: m.cc_faq_a1() },
        { q: m.cc_faq_q2(), a: m.cc_faq_a2() },
        { q: m.cc_faq_q3(), a: m.cc_faq_a3() },
        { q: m.cc_faq_q4(), a: m.cc_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
